<template>
    <va-edit-layout>
        <RefundEventShipmentItemTaxWithheldCharge-form
            :id="id"
            :title="title"
            :item="item"
        ></RefundEventShipmentItemTaxWithheldCharge-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
